import ReactDOM from "react-dom";
import Root from "./Root";

// used for setting hotjar id based on environment
window._env.HOTJAR_ID = process.env.REACT_APP_HOTJAR_ID;

ReactDOM.render(<Root />, document.getElementById("root"));
